export default "__VITE_ASSET__BXQ9dFT___"